import { PanelLeftOpen } from "lucide-react";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";
import { treeChromeInteractiveClass } from "@/components/course/tree/treeStyles";
import { cn } from "@/lib/utils";

interface MiniSidebarHeaderProps {
  onExpand?: () => void;
}

export const MiniSidebarHeader = ({ onExpand }: MiniSidebarHeaderProps) => {
  return (
    <div className="sticky top-0 z-10 bg-white border-b border-gray-200 px-3 py-3">
      <div className="flex items-center justify-end">
        {onExpand && (
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                onClick={onExpand}
                className={cn(
                  "shrink-0 p-1.5 rounded-md hover:bg-gray-100 transition-colors cursor-pointer",
                  treeChromeInteractiveClass
                )}
              >
                <PanelLeftOpen className="w-4 h-4" />
              </button>
            </TooltipTrigger>
            <TooltipContent side="right">Seitenleiste erweitern</TooltipContent>
          </Tooltip>
        )}
      </div>
    </div>
  );
};
